import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const PersonalitySelector = ({ personalityTypes, selectedPersonality, setSelectedPersonality, onStart, onBack }) => {
  return (
    <Card data-testid="personality-select-card" className="glass border-0">
      <CardHeader>
        <CardTitle>Choisissez la Personnalité du Citoyen</CardTitle>
        <CardDescription>
          Sélectionnez le type de personnalité pour diversifier votre entraînement
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {personalityTypes.map((personality) => (
              <button
                key={personality.id}
                onClick={() => setSelectedPersonality(personality)}
                data-testid={`personality-${personality.id}`}
                className={`p-4 rounded-xl border-2 transition-all text-left hover:shadow-md ${
                  selectedPersonality?.id === personality.id
                    ? 'border-2'
                    : 'border-gray-200 hover:border-blue-200'
                }`}
                style={selectedPersonality?.id === personality.id ? { borderColor: '#2E6CF5', backgroundColor: '#CAE9FA' } : {}}
              >
                <div className="flex items-center space-x-3 mb-2">
                  <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${personality.color} flex items-center justify-center text-white text-xl`}>
                    {personality.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold" style={{ color: '#002768' }}>{personality.name}</h3>
                  </div>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">{personality.description}</p>
              </button>
            ))}
          </div>

          {selectedPersonality && (
            <div className="p-4 rounded-lg" style={{ backgroundColor: '#CAE9FA' }}>
              <h4 className="font-semibold mb-2" style={{ color: '#002768' }}>Personnalité sélectionnée:</h4>
              <div className="flex items-center space-x-2">
                <span className="text-2xl">{selectedPersonality.icon}</span>
                <div>
                  <span className="font-medium" style={{ color: '#002768' }}>{selectedPersonality.name}</span>
                  <p className="text-sm" style={{ color: '#2E6CF5' }}>{selectedPersonality.description}</p>
                </div>
              </div>
            </div>
          )}

          <div className="flex space-x-3">
            <button
              onClick={onBack}
              className="flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50"
            >
              Retour
            </button>
            <button
              onClick={onStart}
              disabled={!selectedPersonality}
              data-testid="start-training-button"
              className="flex-1 py-3 text-white rounded-lg font-semibold hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ background: 'linear-gradient(to right, #002768, #2E6CF5)' }}
            >
              Démarrer l'Entraînement
            </button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PersonalitySelector;
